module.exports = __webpack_public_path__ + "static/background-2-e9c301cad2b9fd992a1b88f2ea9bac25.jpg";